export default __webpack_public_path__ + "static/media/headshot.1e031723.png";